export const CART_ITEMS_STORAGE_KEY = "cartItems";
export const CART_UPDATED_EVENT = "cartUpdated";

export type CartItem = {
  id: string;
  productId: string;
  date: string;
  time: string;
  isPrivateTour?: boolean;
  privatePrice?: number;
  guideId?: string;
  guests: Array<{
    productPriceId: string;
    quantity: number;
  }>;
  requests?: string;
  guestNames?: string[];
  pickupLocation?: {
    name: string;
    address: string;
    mapsUrl: string;
  };
};

export function getCartItems(): CartItem[] {
  if (typeof window === "undefined") return [];

  const storedCartItems = window.localStorage.getItem(CART_ITEMS_STORAGE_KEY);
  if (!storedCartItems) return [];

  try {
    const cartItems: unknown = JSON.parse(storedCartItems);
    return Array.isArray(cartItems) ? (cartItems as CartItem[]) : [];
  } catch (error) {
    console.error("Failed to parse cart items from localStorage", error);
    return [];
  }
}

export function saveCartItems(cartItems: CartItem[]) {
  if (typeof window === "undefined") return;

  window.localStorage.setItem(CART_ITEMS_STORAGE_KEY, JSON.stringify(cartItems));
  window.dispatchEvent(new Event(CART_UPDATED_EVENT));
}

export function getCartItemCount() {
  return getCartItems().length;
}
